import { BaseTextMergeContainerElement } from "../BaseTextMergeContainerElement";
import { StateManager } from "../../../Common/StateManager";
import { TextMergeConfiguration } from "../../TextMergeConfiguration";
import { TextMergeType } from "../../TextMergeType";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { XMLAttributeElement } from "./XMLAttributeElement";
import { DataUtilities } from "../../../Common/DataUtilities";

export class JSONXMLBuildObjectElement extends BaseTextMergeContainerElement {
    readonly __type: string = "jsonbuildobject";
    readonly name: string = "Build Object";
    readonly ordinal: number = 5;
    readonly styleElement: boolean = false;

    constructor(fieldName?: string) {
        super();

        if (fieldName) this._fieldName = fieldName;
    }

    private _fieldName: string = "FieldName";

    get fieldName(): string {
        return this._fieldName;
    }

    set fieldName(value: string) {
        this._fieldName = value;
        StateManager.propertyChanged(this, "fieldName");
    }

    canAdd(config: TextMergeConfiguration): boolean {
        return config.type === TextMergeType.JSON || config.type === TextMergeType.XML;
    }

    getHTMLTag(): string {
        return "";
    }

    override output(
        data: ExecutionData,
        config: TextMergeConfiguration,
        testContext: ITestingContext | undefined
    ): string {
        if (config.type === TextMergeType.XML) {
            return XMLAttributeElement.outputXMLContainer(config, this, this._fieldName, data, testContext);
        } else {
            // JSON
            let output = DataUtilities.getIndent(this.getDepth()) + '"' + this._fieldName + '": { \n';

            for (let e of this.elements) {
                output = output + e.output(data, config, testContext);
                if (this.elements.indexOf(e) === this.elements.length - 1) output = output + "\n";
                else output = output + ",\n";
            }

            if (output.endsWith("\n")) {
                output = output + DataUtilities.getIndent(this.getDepth()) + "}";
            } else {
                output = output + "\n" + DataUtilities.getIndent(this.getDepth()) + "}";
            }
            return output;
        }
    }

    override getStorageData(): object {
        let d = super.getStorageData();

        Reflect.set(d, "fieldName", this._fieldName);

        return d;
    }

    override setStorageData(d: object) {
        super.setStorageData(d);

        this._fieldName = Reflect.get(d, "fieldName");
    }
}
